import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { push } from "react-router-redux";
import IntlMessages from "util/intlMessages";
import { Alert } from "reactstrap";
import { setOnChange } from "components/special";

import { adminAPI } from "redux/api";
import { apiUrls, formLink } from "./init";

const { api } = adminAPI.actions;

const AddSpecials = (props) => {
  const dispatch = useDispatch();

  const [body, setBody] = useState({ status: "draft" });
  const changeBody = setOnChange(body, setBody);
  const [error, setError] = useState(false);

  const saveHandler = (req, res) => {
    const onSuccess = (body) => {
      dispatch(push(formLink(body)));
    };
    const onFailure = ({ message }) => {
      setError(message);
    };
    props.addSpecials({ body }, { onSuccess, onFailure });
  };

  const [openModal, setOpenModal] = useState(false);
  const toggleModal = () => setOpenModal(!openModal);

  useEffect(() => {
    setBody({});
  }, [openModal]);

  return (
    <>
      <button className="btn btn-sm -btn-secondary" onClick={toggleModal}>
        <i className="fa fa-plus" />
      </button>
      {openModal && (
        <Modal isOpen={openModal} centered size="lg" toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            <IntlMessages id={"Specials.Casts.Add"} />
          </ModalHeader>
          <ModalBody>
            {error && (
              <Alert className="alert-danger" isOpen="true" toggle={() => setError(false)}>
                <IntlMessages id={error} />
              </Alert>
            )}
            <div className="form-group">
              <IntlMessages id="Specials.Casts.name">
                {(title) => (
                  <input
                    type="text"
                    value={body.name || ""}
                    name="name"
                    onChange={changeBody}
                    required
                    className="form-control"
                    placeholder={title}
                    autoComplete="off"
                  />
                )}
              </IntlMessages>
            </div>

            <div className="form-group">
              <button
                type="button"
                className="form-control c-primary"
                disabled={!body.name}
                onClick={saveHandler}
              >
                <IntlMessages id="save" />
              </button>
            </div>
            {/* <ChannelData {...{ channel, setChannel, saveHandler }} /> */}
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default connect(null, {
  addSpecials: api.post(apiUrls.list),
})(AddSpecials);
